class PaymentModeController {
    /*@ngInject*/
    constructor($log, $http, CommonService) {
        $log.debug('PaymentModeController initialized');
        this.$log = $log;
        this.$http = $http;
        this.showAddCardButton = true;
        this.paymentMode;
        this.saveInAccount;
        this.CommonService = CommonService;
        this.klarnaPaymentClientToken;
    }

    init(klarnaPaymentClientToken, selectedPaymentMode) {
        this.klarnaPaymentClientToken = klarnaPaymentClientToken;
        this.setPaymentMode(selectedPaymentMode, '');
    }

    addCreditCard() {
        let url = this.CommonService.getBaseUrl() + "/checkout/multi/payment-method/creditcard/add";

        this.$http.post(url, null, null)
            .then((response) => {
                $('#credit-card-registration-form').html(response.data).show();
                this.showAddCardButton = false;
            }, (error) => {
                this.$log.error('cannot add creditcard ' + error.status + ' ' + error.statusText);
            });
    }

    setPaymentMode(paymentMode, disabled) {
        if(disabled !== 'true') {
            this.paymentMode = paymentMode;
        }
    }

    submit(form) {
        this.requestPending = true;
        form.$$element.submit();
    }
}

export default PaymentModeController;
